import { useEffect } from 'react';

interface UseCarouselAutoPlayOptions {
  enabled: boolean;
  interval: number;
  activeIndex: number;
  onAdvance: (options?: { announce?: boolean }) => void;
}

export const useCarouselAutoPlay = ({
  enabled,
  interval,
  activeIndex,
  onAdvance,
}: UseCarouselAutoPlayOptions) => {
  useEffect(() => {
    if (!enabled) return undefined;

    const timerId = window.setTimeout(() => {
      onAdvance({ announce: false });
    }, interval);

    return () => {
      window.clearTimeout(timerId);
    };
  }, [activeIndex, interval, enabled, onAdvance]);
};
